import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';

import { useAccessibleInteractivity } from '../../../hooks';
import Theme from '../../../themes';
import Text from '../../OC/oc-text';

const ParentItem = styled.li`
  font-weight: ${props => (props.selected ? '700' : '500')};
  margin-bottom: 10px;

  a {
    color: ${props => (props.selected ? Theme.colors.brand : '#333333')};
    ${props => (props.selected ? 'padding-left: 15px;' : '')}
    text-decoration: none;

    &:focus,
    &:focus-visible {
      outline-color: ${Theme.colors.brand};
    }

    .hidden {
      display: none;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

const ParentListItem = ({
  count,
  disableBackArrow,
  lastInteractionType,
  name,
  onClick,
  selected,
  title,
  toFocusForAccessibility,
}) => {
  const linkRef = useRef();
  useAccessibleInteractivity(linkRef, onClick);

  useEffect(() => {
    if (lastInteractionType === 'keydown') {
      toFocusForAccessibility &&
        toFocusForAccessibility.current &&
        toFocusForAccessibility.current.focus();
    }
  }, []);

  return (
    <ParentItem key={`${title}-${name}`} selected={selected}>
      <a
        data-track={selected ? 'remove-filter' : 'filter'}
        data-track-filter-name={title}
        data-track-filter-option={name}
        ref={linkRef}
      >
        <i
          className={`icon icon-chevron-left ${
            (selected || disableBackArrow) && 'hidden'
          }`}
        />{' '}
        <span>
          <Text content={name} />
          {typeof count !== 'undefined' ? <>&nbsp;{`(${count})`}</> : null}
        </span>
      </a>
    </ParentItem>
  );
};

export default ParentListItem;
